// extracted by mini-css-extract-plugin
export default {"base":"eWevQ","intro":"cfGuu","touContainer":"lkxN1","buttonRow":"uGdCz"};